import gql from 'graphql-tag'

import { AppGetStoresQuery } from '../../../types/api'

export default {
  query: gql`
    query AppGetStores {
      rdvStores {
        id
        name
        isAvailable
        isReturn
        slots {
          id
          closing_hour
          opening_hour
          isAvailable
        }
      }
    }
  `,
  transformer: (response: AppGetStoresQuery) => {
    return response.rdvStores
  },
}
